import React from "react";
import { Link } from "react-router-dom";

export interface HeadlineImageProps {
    src: string;
    alt?: string;
    to?: string;
    size?: "small" | "tiny";
}

export const HeadlineImage = ({ src, alt, to, size }: HeadlineImageProps) => {
    let img: React.ReactNode = [];
    if (src != null) {
        img = <img alt={alt} src={src} />;
    }
    if (to != null) {
        img = <Link to={to}>{img}</Link>;
    }
    let className = "headline-image";
    if (size === "small") {
        className += " headline-image--small";
    }
    else if (size === "tiny") {
        className += " headline-image--tiny";
    }
    return (
        <div className={className}>
            <div className="headline-image__content">
                {img}
            </div>
        </div>
    );
};
